import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IOrganisation } from '@bciti/types';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.scss'],
})
export class FeaturesComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();
    orgTag: string;
    org: IOrganisation;

    breadcrumb: IBreadcrumbItem[] = [
        {
            link: '/organisations',
            title: 'Organisations',
        },
        {
            link: '',
            title: 'Features',
        },
    ];

    constructor(private route: ActivatedRoute, private organisationService: OrganisationService) {}

    ngOnInit(): void {
        this.route.params.subscribe((param) => {
            if (param.tag) {
                this.orgTag = param.tag;
                this.organisationService
                    .getOrganisationByTag(param.tag)
                    .pipe(
                        takeUntil(this.destroy$),
                        tap((org) => (this.org = org)),
                    )
                    .subscribe();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
